import Vue from 'vue'
import gsap from 'gsap'

Vue.prototype.$gsap = gsap

export default gsap

/**
 * 页面区块依次淡入上移
 * @param {Element|Element[]|NodeList} targets
 * @param {object} options
 */
export function fadeUp (targets, options) {
  return gsap.from(targets, Object.assign({
    y: 32,
    opacity: 0,
    duration: 0.7,
    stagger: 0.12,
    ease: 'power2.out',
  }, options || {}))
}



// WEBPACK FOOTER //
// ./src/plugins/gsap.js